@if (isProgressBar) {
  <kendo-progressbar [indeterminate]="true"></kendo-progressbar>
}
@if (!isProgressBar) {
  <div class="loader-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
}

